import {setDisplayName} from 'recompose'

import {wrapDisplayName} from '@jetbrains/teamcity-ui/dist/utils'
import {memo} from 'react'

import type {Enhancer} from '../types'

export default function withHook<AddProps, OwnProps extends {}>(
  useHook: (arg0: OwnProps) => AddProps,
  wrapperName = 'withHook',
): Enhancer<AddProps, OwnProps> {
  return BaseComponent => {
    const WithHook = memo(function WithHookInner(props: OwnProps) {
      const addProps = useHook(props)
      return <BaseComponent {...props} {...addProps} />
    })

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, wrapperName))(WithHook)
    }

    return WithHook
  }
}
